<app-back-button routerLink="/admin"></app-back-button>
<div class="flex justify-end">
  <app-confirm-dialog
    [show]="showConfirmDialog"
    [message]="message"
    (confirm)="onConfirm()"
    (cancel)="onCancel()"
  ></app-confirm-dialog>
  <app-button (click)="openModal()">Adicionar</app-button>
  <app-modal [show]="showModal" (close)="closeModal()">
    <form [formGroup]="merchantRegister" class="w-[500px] grid grid-cols-2 gap-4">
      <app-input formControlName="razaoSocial" placeholder="Razão Social"></app-input>
      <app-input formControlName="nomeFantasia" placeholder="Nome Fantasia"></app-input>
      <app-input formControlName="email" placeholder="Email"></app-input>
      <app-input formControlName="telefone" placeholder="Telefone" phoneMask></app-input>
      <app-input formControlName="cep" placeholder="CEP" cepMask></app-input>
      <app-input formControlName="endereco" placeholder="Endereço"></app-input>
      <app-input formControlName="CNPJ" placeholder="CNPJ" cnpjMask></app-input>
      <app-input formControlName="mcc" placeholder="MCC"></app-input>
      <app-input formControlName="numeroLogico" placeholder="Numero Lógico"></app-input>
    </form>

    <div class="flex justify-end mt-2">
      <app-button (click)="salvar()">Salvar</app-button>
    </div>
  </app-modal>
</div>
<app-loading [show]="loading"></app-loading>
<app-table [columns]="columns" [data]="data"></app-table>
